var path = 'admin/templates/main.html';
var html = "<div ng-if=\"adminCtrl.globalMessage.error\" ng-class=\"adminCtrl.globalMessage.class\" class=\"alert-global\" ng-click=\"adminCtrl.globalMessage.hideGlobalMessage()\">\n  <span ng-repeat=\"message in [].concat(adminCtrl.globalMessage.errorMsg)\">{{message}}<br/></span>\n</div>\n<div class=\"container\">\n  <ui-view></ui-view>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/admin/templates/main.html
 ** module id = 279
 ** module chunks = 0
 **/